import { defineComponent } from 'vue';
import BaseInput from '@/components/BaseForm/BaseInput/BaseInput.vue';
import DropdownIcon from '@/assets/shared/icons/dropdown.svg';
import ArrowUpIcon from '@/assets/shared/icons/arrow-up.svg';
import XMarkIcon from '@/assets/shared/icons/xmark.svg';

export default defineComponent({
  emits: ['update:modelValue', 'change'],
  components: {
    BaseInput,
  },
  props: {
    modelValue: {
      type: String,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    mask: {
      type: String,
    },
    inputmode: {
      type: String,
    },
    availableOptions: {
      type: Array,
    },
    keyLabel: {
      type: String,
      default: 'name',
    },
    keyValue: {
      type: String,
      default: 'value',
    },
    validatorType: {
      type: Array,
    },
    validatorParams: {
      default: null,
    },
    disabled: {
      type: Boolean,
    },
    searchable: {
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean, 
    },
    removeMessages: {
      default: false,
      type: Boolean,
    },
    requiredSign: {
      type: Boolean,
      default: false,
    },
    orderItems: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(newValue) {
      this.selectOptionByValue(newValue);
    },
    removeMessages() {
      this.hasError = false;
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value: any) {
        this.hasError = false;
        this.hasValue = value;
        this.$emit('update:modelValue', value);
      },
    },
    filtredOptions() {
      const tmpOptions = this.availableOptions;

      if (this.orderItems) {
        tmpOptions?.sort((compareA: any, compareB: any) => {
          return compareA[this.keyLabel] < compareB[this.keyLabel]
            ? -1
            : compareA[this.keyLabel] > compareB[this.keyLabel]
            ? 1
            : 0;
        });
      }

      if (!this.searchable || !this.searchTerm) return tmpOptions;

      const sanitizedSearchTerm = this.searchTerm
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      const options = this.availableOptions?.filter((option: any) => {
        const sanitizedEl = option[this.keyLabel]
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
        return sanitizedEl.includes(sanitizedSearchTerm);
      });
      options?.sort((compareA: any, compareB: any) => {
        return compareA[this.keyLabel] < compareB[this.keyLabel]
          ? -1
          : compareA[this.keyLabel] > compareB[this.keyLabel]
          ? 1
          : 0;
      });

      return options;
    },
  },
  data() {
    return {
      hasError: false,
      errorMsg: "",
      openOptions: false,
      selectedLabel: "",
      searchTerm: "",
      dropdownIconPath: DropdownIcon,
      xmarkIconPath: XMarkIcon,
      hasValue: null,
      arrowUpIconPath: ArrowUpIcon,
      keepOpenOptions: false,
    };
  },
  methods: {
    clearInput() {
      this.value = "";
      this.searchTerm = "";
      this.selectedLabel = "";
      this.$emit('change', "");
      setTimeout(() => {
        document.querySelector<HTMLInputElement>(`input[placeholder="${this.placeholder}"]`)?.focus()
      }, 150);
    },
    focusSearch() {
      this.searchTerm = "";
      this.openOptions = true;
    },
    delayedBlur() {
      setTimeout(() => {
        this.searchTerm = this.selectedLabel as string;
        this.openOptions = false;
      }, 100);
    },
    keyUpSearch(event: any) {
      this.searchTerm = event;
    },
    toggleOptions() {
      this.openOptions = !this.openOptions;
    },
    selectOptionByValue(value: any) {
      this.availableOptions?.forEach((option: any) => {
        const optionSanitezed = option[this.keyValue]
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        const valueSanitezed = value
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        if (optionSanitezed == valueSanitezed) {
          this.selectOption(option);
          this.toggleOptions();
        } else if (valueSanitezed === '') {
          this.selectedLabel = '';
          this.searchTerm = '';
        }
      });
    },
    selectOption(value: any) {
      this.value = value[this.keyValue];
      this.searchTerm = value[this.keyLabel];
      this.selectedLabel = value[this.keyLabel];
      this.toggleOptions();
      this.$emit('change', value);
    },
  },
});
